import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "Slices/Response/responseSlice";
import { setToast, setLoading, setModal } from "Slices/uiSlice";
import {
  adminEncuestas,
  adminPreguntas,
  adminRespuestas,
  getEncuestas,
  getPreguntasEncuesta,
  getRespuestasPregunta,
  getTipoPregunta,
  getTipoRespuesta
} from "Services/encuesta_service";

const initialState = {
  encuestas: [],
  encuesta: {
    nombre: '',
    estado: 1,
  },
  tipoPregunta: [],
  preguntas: [],
  pregunta: {
    idPregunta: null,
    idEncuesta: null,
    pregunta: '',
    tipo: 1,
    estado: 1,
    opciones: [],
  },
  respuestas: [],
  respuesta: {
    idRespuesta: null,
    idPregunta: null,
    respuesta: '',
    estado: 1,
  },
  tipoRespuesta: [],
};

export const encuestaSlice = createSlice({
  name: 'encuesta',
  initialState,
  reducers: {
    setEncuestas: (state, action) => {
      state.encuestas = action.payload;
    },
    setEncuesta: (state, action) => {
      state.encuesta = action.payload ?? initialState.encuesta;
    },
    setPreguntas: (state, action) => {
      state.preguntas = action.payload;
    },
    setPregunta: (state, action) => {
      state.pregunta = action.payload ?? initialState.pregunta;
    },
    setTipoPregunta: (state, action) => {
      state.tipoPregunta = action.payload;
    },
    setTipoRespuesta: (state, action) => {
      state.tipoRespuesta = action.payload;
    },
    setRespuestas: (state, action) => {
      state.respuestas = action.payload;
    },
    setRespuesta: (state, action) => {
      state.respuesta = action.payload ?? initialState.respuesta;
    }
  }
});

// ─── Thunks ───────────────────────────────────────────────

export const fetchEncuestas = createAsyncThunk(
  'encuesta/fetchEncuestas',
  async (data, { dispatch }) => {
    const encuestasRes = await getEncuestas(data);
    dispatch(setEncuestas(encuestasRes));
  }
);

export const fetchPreguntasEncuesta = createAsyncThunk(
  'encuesta/fetchPreguntasEncuesta',
  async (data, { dispatch }) => {
    const preguntasRes = await getPreguntasEncuesta(data);
    dispatch(setPreguntas(preguntasRes));
  }
);

export const fetchRespuestasPregunta = createAsyncThunk(
  'encuesta/fetchRespuestasPregunta',
  async (idPregunta, { dispatch }) => {
    const respuestasRes = await getRespuestasPregunta(idPregunta);
    dispatch(setRespuestas(respuestasRes));
  }
);


export const fetchEncuestaById = createAsyncThunk(
  'encuesta/fetchEncuestaById',
  async (data, { dispatch }) => {
    const encuestasRes = await getEncuestas(data);
    dispatch(setEncuesta(encuestasRes[0]));
  }
);

export const fetchTipoPregunta = createAsyncThunk(
  'encuesta/fetchTipoPregunta',
  async (_, { dispatch }) => {
    const tipoPreguntaRes = await getTipoPregunta();
    dispatch(setTipoPregunta(tipoPreguntaRes));
  }
);

export const fetchTipoRespuesta = createAsyncThunk(
  'encuesta/fetchTipoRespuesta',
  async (_, { dispatch }) => {
    const tipoRespuestaRes = await getTipoRespuesta();
    dispatch(setTipoRespuesta(tipoRespuestaRes));
  }
);

export const mergeEncuesta = createAsyncThunk(
  'encuesta/mergeEncuesta',
  async (data, { dispatch }) => {
    dispatch(setLoading(true));
    const encuestaRes = await adminEncuestas(data);
    dispatch(setResponse(encuestaRes));
    dispatch(setLoading(false));
    dispatch(setModal(false));
    dispatch(setToast(true));
    dispatch(fetchEncuestas({ idEncuesta: null }));
    setTimeout(() => {
      dispatch(setToast(false));
    }, 3000);
  }
);

export const mergePregunta = createAsyncThunk(
  'encuesta/mergePregunta',
  async (data, { dispatch }) => {
    dispatch(setLoading(true));
    const preguntaRes = await adminPreguntas(data);
    dispatch(setResponse(preguntaRes));
    dispatch(setLoading(false));
    dispatch(setModal(false));
    dispatch(setToast(true));
    dispatch(setPregunta(null));
    dispatch(fetchPreguntasEncuesta({ idEncuesta: data.idEncuesta }));
    setTimeout(() => {
      dispatch(setToast(false));
    }, 3000);
  }
);

export const mergeRespuesta = createAsyncThunk(
  'encuesta/mergeRespuesta',
  async (data, { dispatch }) => {
    dispatch(setLoading(true));
    const respuestaRes = await adminRespuestas(data);
    dispatch(setResponse(respuestaRes));
    dispatch(setLoading(false));
    dispatch(setModal(false));
    dispatch(setToast(true));
    dispatch(setPregunta(null));
    dispatch(fetchRespuestasPregunta({ idPregunta: data?.idPregunta }));
    setTimeout(() => {
      dispatch(setToast(false));
    }, 3000);
  }
);



// ─── Exports ──────────────────────────────────────────────

export const {
  setEncuestas,
  setEncuesta,
  setPreguntas,
  setPregunta,
  setTipoPregunta,
  setTipoRespuesta,
  setRespuestas,
  setRespuesta,
  updateRespuesta
} = encuestaSlice.actions;

export default encuestaSlice.reducer;
